import type { Conversation } from "@/conversations/types";
import type { User } from "@/users/types";
import { computed, toValue, type MaybeRefOrGetter } from "vue";

export function useConversationPermissions(
  me: MaybeRefOrGetter<User | undefined>,
  conversation: MaybeRefOrGetter<Conversation | undefined> = () => undefined,
) {
  const isAuthor = computed(
    () =>
      toValue(me) !== undefined &&
      toValue(me)?.id === toValue(conversation)?.userId,
  );

  const canEdit = computed(() => isAuthor.value);

  const canDelete = computed(
    () =>
      isAuthor.value ||
      toValue(me)?.role === "Admin" ||
      toValue(me)?.role === "Coordinator",
  );

  const canSetContent = computed(() => toValue(me)?.role !== "Supporter");

  return { canEdit, canDelete, canSetContent };
}
